import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ className = '' }) => {
  const actions = [
    {
      id: 'reports',
      label: 'Generate Report',
      description: 'Create executive summary',
      icon: 'FileText',
      variant: 'default',
      onClick: () => console.log('Generate report clicked')
    },
    {
      id: 'approvals',
      label: 'Pending Approvals',
      description: '12 items waiting',
      icon: 'CheckSquare',
      variant: 'outline',
      onClick: () => console.log('Approvals clicked')
    },
    {
      id: 'meeting',
      label: 'Schedule Meeting',
      description: 'Book executive session',
      icon: 'Calendar',
      variant: 'outline',
      onClick: () => console.log('Schedule meeting clicked')
    },
    {
      id: 'export',
      label: 'Export Data',
      description: 'Download dashboard data',
      icon: 'Download',
      variant: 'ghost',
      onClick: () => console.log('Export data clicked')
    }
  ];

  return (
    <div className={`bg-card border border-border rounded-lg p-6 card-shadow ${className}`}>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Quick Actions</h3>
          <p className="text-sm text-muted-foreground">Common executive tasks</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action) => (
          <div
            key={action?.id}
            className="p-4 border border-border rounded-lg hover:bg-muted/50 transition-smooth cursor-pointer"
            onClick={action?.onClick}
          >
            <div className="flex items-center space-x-3">
              <Button
                variant={action?.variant}
                size="icon"
                iconName={action?.icon}
                onClick={(e) => {
                  e?.stopPropagation();
                  action?.onClick();
                }}
              />
              <div className="flex-1">
                <h4 className="text-sm font-medium text-foreground">{action?.label}</h4>
                <p className="text-xs text-muted-foreground">{action?.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <Button variant="outline" size="sm" fullWidth iconName="Plus">
          Customize Actions
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;